<template>
  <div style="position: relative">
    <FilterFields
      :fields="[
        {
          type: 'number',
          label: 'Código',
          field: 'id_lista_preco_servico',
        },
        {
          type: 'text',
          label: 'Descrição',
          field: 'descricao',
        },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: ['Ativo', 'Inativo'],
        },
      ]"
    />

    <TableApp
      titulo="Lista de Preços de Serviços"
      acaoBtn="/#/lista-precos-servicos/nova"
      textoBtn="Nova"
      api-url="/servicos/lista-preco"
      :fields="fields"
      classFilterColumn="descricao"
      ref="listaPrecos"
      :perPage="10"
    >
      <template slot="customRow" scope="props">
        <span slot="descricao" v-if="props.field === 'descricao'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <a
                class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
              >
                {{ props.rowData.descricao.substr(0, 50) }}
              </a>
            </div>
          </span>
        </span>

        <span slot="status" v-if="props.field === 'status'">
          <span
            v-if="props.rowData.status"
            class="label label-lg label-inline label-light-success"
          >
            Ativo
          </span>
          <span v-else class="label label-lg label-inline label-light-danger">
            Inativo
          </span>
        </span>

        <span slot="actions" v-if="props.field === 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <router-link
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Editar'"
              :to="{
                name: 'listaPrecoServicoUpdate',
                params: {
                  id_lista_preco_servico: props.rowData.id_lista_preco_servico,
                },
              }"
            >
              <Pencil :size="16" title="Editar" />
            </router-link>
            <button
              @click="excluir(props.rowData)"
              class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Excluir'"
            >
              <TrashCanIcon :size="16" />
            </button>
          </div>
        </span>
      </template>
    </TableApp>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-lista-preco-servico",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: true,
          filterOptions: { enabled: false },
        },
        {
          label: "Status",
          field: "status",
          width: "10%",
          sortable: false,
          slot: true,
          filterOptions: { enabled: false },
        },
        {
          label: "Ações",
          field: "actions",
          width: "15%",
          sortable: false,
          slot: true,
          filterOptions: { enabled: false },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
  methods: {
    excluir(lista) {
      this.$swal
        .fire({
          icon: "warning",
          title: `Excluir a lista ${lista.descricao}?`,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (!result.isConfirmed) return;

          await this.$http.post("/servicos/lista-preco/delete", {
            id_lista_preco_servico: lista.id_lista_preco_servico,
          });
          this.$refs.listaPrecos.refresh();
          this.$toast.success("Lista de preços de serviços excluída!");
        });
    },
  },
};
</script>
